import { render, staticRenderFns } from "./TreeviewSelect.vue?vue&type=template&id=b00804c8"
import script from "./TreeviewSelect.vue?vue&type=script&lang=js"
export * from "./TreeviewSelect.vue?vue&type=script&lang=js"
import style0 from "./TreeviewSelect.vue?vue&type=style&index=0&id=b00804c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports